var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
export class PureLink {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: '*255?O01!',
                next: /\*\d+s\?.+/i,
            },
        ];
        // Factory default device ID is 255. 999 addresses all units
        this.deviceId = 255;
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`*${this.deviceId}?VERSIONCT!`, /^\*\d+s\?\s?VERSIONCT:.+-V(.+)!/i, tags);
                return match[1];
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`*${this.deviceId}?O${key}!`, /\*\d+s\?\s?I(\d+)O(\d+)!/i, tags);
                // return the input
                return match[1];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`*${this.deviceId}CI${value}O${key}!`, /\*\d+sC\s?I(\d+)O(\d+)!/i, tags);
                // return the input
                return match[1];
            }),
            asyncHandlers: {
                regExp: /\*\d+sC\s?I(\d+)O(\d+)!/i,
                callback: (match) => {
                    const key = match[2];
                    const value = match[1];
                    this.state.videoMatrixRoutes.update(key, value);
                },
            },
        };
        // polling
        this.polls = [
            {
                intervalMs: 5000,
                controls: ['videoMatrixRoutes'],
            },
        ];
    }
    // phase callbacks
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
PureLink.driverType = 'socketDriver';
PureLink.key = '-MSdGliCxVWRPvQPlGUo';
PureLink.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
PureLink.socketOptions = [
    Object.assign(Object.assign({}, PureLink.baseSocketOptions), { port: 23 }),
    Object.assign(Object.assign({}, PureLink.baseSocketOptions), { port: 4999 }),
];
